import Owner from '@/extend/classes/Owner';
import Rib from '@/extend/classes/Rib';
import { ColumnFilter, ListChoix, ListFilter } from '@/extend/classes/ListData';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import RibSummary from '@/generated/controls/rib/RibSummary.vue';
import { storeSession } from '@/generated/stores';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: RibSummary,
    data() {
        const activeFilters: ColumnFilter[] = [];

        return {
            activeFilters
        };
    },
    computed: {
        clientId(): number {
            const user = storeSession.connectedUser;
            if (user) {
              return user.clientId;
            }
            return 0;
        },
        filter(): ListFilter {
            const filter = new ListFilter();
                this.setNotOrdered(true);
                {
                  const columnFilter = new ColumnFilter();
                  columnFilter.name = "ownerType";
                  columnFilter.staticFilter = true;
                  const choix = new ListChoix();
                  choix.value = ObjTypes.CLIENT;
                  columnFilter.filters.push(choix);
                  this.addFilter(columnFilter);
                }
                {
                  const columnFilter = new ColumnFilter();
                  columnFilter.name = "ownerId";
                  columnFilter.staticFilter = true;
                  const choix = new ListChoix();
                  choix.value = this.clientId;;
                  columnFilter.filters.push(choix);
                  this.addFilter(columnFilter);
                }
                filter.columnsFilter = this.activeFilters;

                return filter;
        }
    },
    methods: {
        setNotOrdered(value: boolean) {
            this.notOrdered = value;
        },
        addFilter(columnFilter: ColumnFilter) {
            this.activeFilters.push(columnFilter);
        },
        getDisplay(rib: Rib): string {
            return rib.display;
        },
        setAttribut(rib: Rib, owner: Owner, parentObj: unknown): void {
            const ribOwner = new Owner();
            ribOwner.objType = ObjTypes.CLIENT;
            ribOwner.objId = this.clientId;

            if (JSON.stringify(rib.owner) != JSON.stringify(ribOwner)) {
                rib.owner = ribOwner;
            }
        }
    }
})
